export default "__VITE_ASSET__W7xjxsNe__"